// frontend/src/pages/Auth/Login.js

import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Login = () => {
  const { user, login } = useContext(AuthContext);
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const from = location.state?.from?.pathname || '/';

  if (user) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password);
    if (!result.success) {
      setError(result.message || 'Anmeldung fehlgeschlagen');
    }
  };

  return (
    <motion.div
      className="max-w-md mx-auto bg-white p-8 rounded shadow mt-10"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-2xl font-heading text-center text-primary mb-6">
        Anmeldung bei Entecity.ch
      </h2>
      {error && (
        <div className="bg-red-100 text-red-700 p-3 rounded mb-4">{error}</div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-text font-body mb-1">E-Mail</label>
          <input
            type="email"
            className="w-full px-4 py-2 border border-accent rounded focus:outline-none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-label="E-Mail-Adresse"
          />
        </div>
        <div>
          <label className="block text-text font-body mb-1">Passwort</label>
          <input
            type="password"
            className="w-full px-4 py-2 border border-accent rounded focus:outline-none"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            aria-label="Passwort"
          />
        </div>
        <button
          type="submit"
          className="w-full bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 transition"
        >
          Anmelden
        </button>
      </form>
      <div className="text-center mt-4">
        <a href="/forgot-password" className="text-sm text-blue-500 hover:underline">
          Passwort vergessen?
        </a>
      </div>
    </motion.div>
  );
};

export default Login;
